import React, { useEffect, useState } from 'react';

import styles from './DogCardLooseRadar.module.scss';
import { useTranslate } from 'react-polyglot';
import { useAuth } from '../../../../../../Auth';
import { useAxios } from '../../../../../../AxiosHandler';
import RadarCard from '../../../../Statistics/Cards/RadarCard/RadarCard';

function DogCardLooseRadar(props: DogCardLooseRadarProps) {
    const t = useTranslate();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [data, setData] = useState<any>();

    function getData() {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/dog/" + props.dogId + "/use/loose/breedingvalues",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            setData({
                labels: res.data.map((item: any) => {
                    return t("dog.statistics.looseradar.labels." + item["LABEL"]);
                }),
                datasets: [
                    {
                        label: t("dog.statistics.looseradar.dataset_title"),
                        pointBackgroundColor: res.data.map((item: any) => {
                            if (item["ACCURACY"] > 0.6) {
                                return "#68DB5A"; // Green
                            } else if (item["ACCURACY"] > 0.3) {
                                return "#e1e855"; // Yellow
                            } else {
                                return "#e16a6a"; // Red
                            }
                        }),
                        data: res.data.map((item: any) => {
                            return item["EBV"];
                        }),
                    },
                    // Average dataset at 100
                    {
                        label: t("dog.statistics.looseradar.dataset_average"),
                        data: [100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100],
                        backgroundColor: "#00000000",
                        borderColor: "#00000099",
                        pointRadius: 0,
                    }
                ]
            });
            props.onDataLoaded?.(res.data);
        }).catch((err: any) => {
            console.log(err);
        });
    }

    useEffect(() => {
        if (auth.selectedBreed != undefined) {
            getData();
        }
    }, [auth.selectedBreed]);

    return (
        <div className={styles.statisticshealth}>
            <RadarCard
                title={t("dog.statistics.looseradar_breedingvalues.title")}
                data={data}
                description={t("dog.statistics.looseradar_breedingvalues.description")}
            ></RadarCard>
        </div>
    );
}

class DogCardLooseRadarProps {
    dogId!: string | undefined;
    onDataLoaded?: (data: any) => void;
}

export default DogCardLooseRadar;